<script>
import Title from "@/components/admin/common/TitleArea.vue"
import StatusBadge from "@/components/fulfillment/StatusBadge.vue"
import DataTable from "@/components/fulfillment/DataTable.vue"
import PageGuideDialog from "@/components/admin/fulfillment/guide/PageGuideDialog.vue"
import FulfillmentPageGuide from "@/components/admin/fulfillment/guide/FulfillmentPageGuide.vue"

export default {
  name: 'AdminMasterSkuList',
  components: {
    Title,
    StatusBadge,
    DataTable,
    PageGuideDialog,
    FulfillmentPageGuide
  },
  data() {
    return {
      description: {
        title: '목록 조회'
      },
      filters: {
        brand_id: '',
        category_id: '',
        hs_code: '',
        spec_type: '',
        is_active: '',
        registration_status: '',
        mapping_status: '',
        q: ''
      },
      specTypeOptions: [
        { label: '전체', value: '' },
        { label: 'APPAREL_SIZE', value: 'APPAREL_SIZE' },
        { label: 'PRODUCT_OPTION', value: 'PRODUCT_OPTION' },
        { label: 'PACK_COUNT', value: 'PACK_COUNT' },
      ],
      activeOptions: [
        { label: '전체', value: '' },
        { label: '활성', value: true },
        { label: '비활성', value: false },
      ],
      registrationStatusOptions: [
        { label: '전체', value: '' },
        { label: '가등록', value: 'DRAFT' },
        { label: '확정등록', value: 'CONFIRMED' },
      ],
      rows: [],
      listLoading: false,
      loadingMore: false,
      hasNext: false,
      guideDialog: false,
      pagination: { page: 1, rowsPerPage: 20 },
      masterDataLoading: false,
      brands: [],
      categories: [],
      packUnitTypes: [],
    }
  },
  computed: {
    quickFilters() {
      return [
        { label: '전체', value: '', icon: 'inventory_2' },
        { label: '정상 연결', value: 'MAPPED', icon: 'link' },
        { label: '미연결', value: 'UNMAPPED', icon: 'link_off' },
        { label: '비활성', value: 'INACTIVE', icon: 'block' },
      ]
    },
    appliedFilters() {
      const filters = []
      const brand = this.brands.find(item => item.brand_id === this.filters.brand_id)
      const category = this.categories.find(item => item.category_id === this.filters.category_id)

      if (this.filters.q) filters.push({ key: 'q', label: `검색어: ${this.filters.q}` })
      if (brand) filters.push({ key: 'brand_id', label: `브랜드: ${brand.name}` })
      if (category) filters.push({ key: 'category_id', label: `카테고리: ${category.name}` })
      if (this.filters.hs_code) filters.push({ key: 'hs_code', label: `HS CODE: ${this.filters.hs_code}` })
      if (this.filters.spec_type) filters.push({ key: 'spec_type', label: `규격: ${this.filters.spec_type}` })
      if (this.filters.is_active !== '') {
        filters.push({ key: 'is_active', label: `활성 여부: ${this.filters.is_active ? '활성' : '비활성'}` })
      }
      if (this.filters.registration_status) {
        const registrationStatus = this.registrationStatusOptions.find(item => item.value === this.filters.registration_status)
        filters.push({ key: 'registration_status', label: `등록상태: ${registrationStatus?.label || this.filters.registration_status}` })
      }
      if (this.filters.mapping_status) {
        const mappingStatus = this.quickFilters.find(item => item.value === this.filters.mapping_status)
        filters.push({ key: 'mapping_status', label: `연결 상태: ${mappingStatus?.label || this.filters.mapping_status}` })
      }

      return filters
    },
    columns() {
      return [
        { name: 'display_name', label: '상품명', field: 'display_name', align: 'left' },
        { name: 'master_sku_code', label: '마스터 SKU', field: 'master_sku_code', align: 'left' },
        { name: 'barcode', label: '바코드', field: row => row.barcode || '-', align: 'left' },
        { name: 'brand_name', label: '브랜드', field: 'brand_name', align: 'left' },
        { name: 'category_name', label: '카테고리', field: 'category_name', align: 'left' },
        { name: 'hs_code', label: 'HS CODE', field: 'hs_code', align: 'left' },
        { name: 'partner_sku_count', label: '연결 SKU', field: 'partner_sku_count', align: 'right' },
        { name: 'mapping_status', label: '연결 상태', field: 'mapping_status', align: 'center' },
        { name: 'partner_names', label: '연결 파트너', field: row => row.partner_names || '-', align: 'left' },
        { name: 'partner_barcodes', label: '연결 바코드', field: row => row.partner_barcodes || row.request_barcodes || '-', align: 'left' },
        { name: 'registration_status', label: '등록상태', field: row => row.registration_status || 'CONFIRMED', align: 'center' },
        { name: 'is_active', label: '활성', field: row => row.is_active ? 'ACTIVE' : 'INACTIVE', align: 'center' },
        { name: 'updated_at', label: '최근 수정일', field: row => this.formatDateTime(row.updated_at), align: 'left' },
        { name: 'actions', label: '', field: 'actions', align: 'center' },
      ]
    },
    tablePagination() {
      return { page: 1, rowsPerPage: 0 }
    }
  },
  methods: {
    applyRouteFilters() {
      const query = this.$route?.query || {}
      const numericValue = (value) => value && /^\d+$/.test(String(value)) ? Number(value) : value || ''

      this.filters = {
        brand_id: numericValue(query.brand_id),
        category_id: numericValue(query.category_id),
        hs_code: String(query.hs_code || ''),
        spec_type: String(query.spec_type || ''),
        is_active: query.is_active === 'true' ? true : query.is_active === 'false' ? false : '',
        registration_status: String(query.registration_status || ''),
        mapping_status: String(query.mapping_status || ''),
        q: String(query.q || '')
      }
    },
    syncRouteFilters() {
      const query = {}
      Object.entries(this.filters).forEach(([key, value]) => {
        if (value !== '' && value !== null && value !== undefined) {
          query[key] = String(value)
        }
      })
      this.$router.replace({ path: this.$route.path, query }).catch(() => {})
    },
    applyRouteContext() {
      const routeTitle = String(this.$route?.meta?.title || '').replace(/^Aone 관리자 \|\s*/, '')
      if (routeTitle) {
        this.description.title = routeTitle
      }
    },
    async loadMasterData() {
      this.masterDataLoading = true

      const brandConfig = {
        method: 'GET',
        url: '/api/fulfillment/brands',
        name: '[ Fulfillment / 브랜드 목록 ]'
      }
      const categoryConfig = {
        method: 'GET',
        url: '/api/fulfillment/categories',
        name: '[ Fulfillment / 카테고리 목록 ]'
      }
      const packUnitConfig = {
        method: 'GET',
        url: '/api/fulfillment/pack-unit-types',
        name: '[ Fulfillment / 패키지 단위 목록 ]'
      }

      await this.$http(brandConfig)
        .then(res => { this.brands = res.data?.data || [] })
        .catch(() => { this.brands = [] })

      await this.$http(categoryConfig)
        .then(res => { this.categories = res.data?.data || [] })
        .catch(() => { this.categories = [] })

      await this.$http(packUnitConfig)
        .then(res => { this.packUnitTypes = res.data?.data || [] })
        .catch(() => { this.packUnitTypes = [] })

      this.masterDataLoading = false
    },
    async loadList() {
      this.listLoading = true
      this.hasNext = false
      const query = new URLSearchParams({
        brand_id: this.filters.brand_id || '',
        category_id: this.filters.category_id || '',
        hs_code: this.filters.hs_code || '',
        spec_type: this.filters.spec_type || '',
        is_active: this.filters.is_active === '' ? '' : String(this.filters.is_active),
        registration_status: this.filters.registration_status || '',
        mapping_status: this.filters.mapping_status || '',
        q: this.filters.q || '',
        page: String(this.pagination.page),
        pageSize: String(this.pagination.rowsPerPage),
        lazy: '1',
      })
      const config = {
        method: 'GET',
        url: `/api/fulfillment/admin/master-skus?${query.toString()}`,
        name: '[ Fulfillment / Master SKU 목록 ]'
      }
      await this.$http(config)
        .then(res => {
          const data = res.data?.data
          if (Array.isArray(data)) this.rows = data
          else if (Array.isArray(data?.items)) this.rows = data.items
          else if (Array.isArray(data?.list)) this.rows = data.list
          else this.rows = []
          this.hasNext = Boolean(data?.hasNext)
        })
        .catch(() => {
          this.rows = []
          this.hasNext = false
        })
      this.listLoading = false
    },
    async loadMore() {
      if (this.listLoading || this.loadingMore || !this.hasNext) return
      this.loadingMore = true
      this.pagination.page += 1
      const query = new URLSearchParams({
        brand_id: this.filters.brand_id || '',
        category_id: this.filters.category_id || '',
        hs_code: this.filters.hs_code || '',
        spec_type: this.filters.spec_type || '',
        is_active: this.filters.is_active === '' ? '' : String(this.filters.is_active),
        registration_status: this.filters.registration_status || '',
        mapping_status: this.filters.mapping_status || '',
        q: this.filters.q || '',
        page: String(this.pagination.page),
        pageSize: String(this.pagination.rowsPerPage),
        lazy: '1',
      })
      const config = {
        method: 'GET',
        url: `/api/fulfillment/admin/master-skus?${query.toString()}`,
        name: '[ Fulfillment / Master SKU 목록 더보기 ]'
      }
      await this.$http(config)
        .then(res => {
          const data = res.data?.data
          const nextRows = Array.isArray(data)
            ? data
            : Array.isArray(data?.items)
              ? data.items
              : Array.isArray(data?.list)
                ? data.list
                : []
          this.rows = [...this.rows, ...nextRows]
          this.hasNext = Boolean(data?.hasNext)
        })
        .catch(() => {
          this.pagination.page -= 1
          this.hasNext = false
        })
      this.loadingMore = false
    },
    onSearch() {
      this.pagination.page = 1
      this.hasNext = false
      this.syncRouteFilters()
      this.loadList()
    },
    setMappingStatus(value) {
      this.filters.mapping_status = value
      this.onSearch()
    },
    removeFilter(key) {
      this.filters[key] = ''
      this.onSearch()
    },
    resetFilters() {
      Object.keys(this.filters).forEach(key => {
        this.filters[key] = ''
      })
      this.onSearch()
    },
    formatDateTime(value) {
      return value ? this.$formatDate(value, 'YYYY-MM-DD HH:mm:ss') : '-'
    },
    goToRegister() {
      this.$router.push('/admin/fulfillment/products/register')
    },
    goToDetail(row) {
      if (!row || !row.master_sku_id) return
      this.$router.push({
        path: `/admin/fulfillment/master-skus/${row.master_sku_id}`,
        query: {
          returnQuery: JSON.stringify(this.$route.query || {})
        }
      })
    },
    onRowClick({ row }) {
      this.goToDetail(row)
    }
  },
  mounted() {
    this.applyRouteContext()
    this.applyRouteFilters()
    this.loadMasterData()
    this.loadList()
  }
}
</script>

<template>
  <q-page class="q-pa-lg">
    <div class="row q-mb-lg">
      <div class="col">
        <Title :desc="description">
          <template #title-action>
            <q-btn flat round dense size="sm" color="primary" icon="help_outline" aria-label="목록 조회 사용 가이드" @click="guideDialog = true">
              <q-tooltip>목록 조회 사용 가이드</q-tooltip>
            </q-btn>
          </template>
          <q-btn
            color="primary"
            icon="add"
            label="신규 등록"
            unelevated
            @click="goToRegister"
          />
        </Title>
      </div>
    </div>

    <div class="row q-mb-md">
      <div class="col">
        <div class="comp-box">
          <div class="text-subtitle1 text-weight-bold">상품 검색</div>
          <div class="text-body2 text-grey-7 q-mt-xs">상품 기준으로 마스터 SKU와 파트너 SKU 연결 현황을 확인합니다.</div>

          <div class="row q-col-gutter-sm q-mt-md">
            <div class="col-12 col-md">
              <q-input
                v-model="filters.q"
                label="상품명 / 마스터 SKU / 브랜드 / 바코드 검색"
                dense
                outlined
                clearable
                @keyup.enter="onSearch"
              >
                <template #prepend>
                  <q-icon name="search" />
                </template>
              </q-input>
            </div>
            <div class="col-12 col-md-auto">
              <q-btn color="primary" icon="search" label="검색" unelevated @click="onSearch" />
              <q-btn class="q-ml-sm" color="grey-7" icon="restart_alt" label="초기화" flat @click="resetFilters" />
            </div>
          </div>

          <div class="quick-filter-row q-mt-md">
            <q-btn
              v-for="filter in quickFilters"
              :key="filter.value || 'all'"
              :color="filters.mapping_status === filter.value ? 'primary' : 'grey-7'"
              :flat="filters.mapping_status !== filter.value"
              :outline="filters.mapping_status !== filter.value"
              :icon="filter.icon"
              :label="filter.label"
              dense
              no-caps
              @click="setMappingStatus(filter.value)"
            />
          </div>

          <q-separator class="q-my-md" />
          <div class="text-caption text-weight-bold text-grey-7 q-mb-sm">상세 조건</div>
          <div class="row q-col-gutter-md">
            <div class="col-12 col-md-3">
              <q-select
                v-model="filters.brand_id"
                :options="brands"
                option-label="name"
                option-value="brand_id"
                emit-value
                map-options
                label="브랜드"
                dense
                outlined
                clearable
              />
            </div>
            <div class="col-12 col-md-3">
              <q-select
                v-model="filters.category_id"
                :options="categories"
                option-label="name"
                option-value="category_id"
                emit-value
                map-options
                label="카테고리"
                dense
                outlined
                clearable
              />
            </div>
            <div class="col-12 col-md-2">
              <q-input
                v-model="filters.hs_code"
                label="HS CODE"
                dense
                outlined
                clearable
              />
            </div>
            <div class="col-12 col-md-2">
              <q-select
                v-model="filters.spec_type"
                :options="specTypeOptions"
                emit-value
                map-options
                label="규격 타입"
                dense
                outlined
                clearable
              />
            </div>
            <div class="col-12 col-md-2">
              <q-select
                v-model="filters.is_active"
                :options="activeOptions"
                emit-value
                map-options
                label="활성 여부"
                dense
                outlined
                clearable
              />
            </div>
            <div class="col-12 col-md-2">
              <q-select
                v-model="filters.registration_status"
                :options="registrationStatusOptions"
                emit-value
                map-options
                label="등록상태"
                dense
                outlined
                clearable
              />
            </div>
          </div>

          <div v-if="appliedFilters.length" class="applied-filter-row q-mt-md">
            <span class="text-caption text-grey-7">적용 조건</span>
            <q-chip
              v-for="filter in appliedFilters"
              :key="filter.key"
              removable
              color="blue-1"
              text-color="primary"
              @remove="removeFilter(filter.key)"
            >
              {{ filter.label }}
            </q-chip>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="comp-box">
          <div class="row items-center justify-between q-mb-md">
            <div>
              <span class="text-subtitle1 text-weight-bold">조회 결과</span>
              <span class="text-body2 text-grey-7 q-ml-sm">현재 {{ rows.length.toLocaleString() }}건 표시</span>
            </div>
            <div class="text-caption text-grey-7">행을 선택하거나 상세보기 아이콘을 눌러 상품 정보를 확인하세요.</div>
          </div>
          <DataTable
            :rows="rows"
            :columns="columns"
            row-key="master_sku_id"
            :loading="listLoading"
            :pagination="tablePagination"
            @row-click="onRowClick"
          >
            <template #body-cell-mapping_status="props">
              <q-td :props="props">
                <StatusBadge :status="props.value" />
              </q-td>
            </template>
            <template #body-cell-is_active="props">
              <q-td :props="props">
                <StatusBadge :status="props.value" />
              </q-td>
            </template>
            <template #body-cell-registration_status="props">
              <q-td :props="props">
                <StatusBadge :status="props.value" />
              </q-td>
            </template>
            <template #body-cell-partner_names="props">
              <q-td :props="props">
                <div class="partner-names ellipsis">
                  {{ props.value }}
                  <q-tooltip v-if="props.value !== '-'">{{ props.value }}</q-tooltip>
                </div>
              </q-td>
            </template>
            <template #body-cell-partner_barcodes="props">
              <q-td :props="props">
                <div class="partner-names ellipsis">
                  {{ props.value }}
                  <q-tooltip v-if="props.value !== '-'">{{ props.value }}</q-tooltip>
                </div>
              </q-td>
            </template>
            <template #body-cell-actions="props">
              <q-td :props="props">
                <q-btn
                  icon="open_in_new"
                  color="primary"
                  flat
                  round
                  dense
                  aria-label="상품 상세보기"
                  @click.stop="goToDetail(props.row)"
                >
                  <q-tooltip>상품 상세보기</q-tooltip>
                </q-btn>
              </q-td>
            </template>
            <template #no-data>
              <div class="full-width column flex-center q-pa-xl text-grey-7">
                <q-icon name="search_off" size="36px" class="q-mb-sm" />
                <div class="text-body2">조건에 맞는 상품이 없습니다.</div>
                <div class="text-caption q-mt-xs">검색어 또는 필터 조건을 변경해 다시 조회하세요.</div>
              </div>
            </template>
          </DataTable>
          <div class="row items-center justify-between q-pa-md table-load-more">
            <div class="text-caption text-grey-7">
              현재 {{ rows.length.toLocaleString() }}건 표시
            </div>
            <q-btn
              v-if="hasNext"
              outline
              color="primary"
              label="더보기"
              :loading="loadingMore"
              :disable="listLoading || loadingMore"
              @click="loadMore"
            />
          </div>
        </div>
      </div>
    </div>

    <PageGuideDialog
      v-model="guideDialog"
      title="목록 조회 사용 가이드"
      description="등록된 기준 상품 검색과 연결 현황 확인 방법입니다."
    >
      <FulfillmentPageGuide guide-key="masterSkuList" />
    </PageGuideDialog>
  </q-page>
</template>

<style scoped>
.quick-filter-row,
.applied-filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.partner-names {
  max-width: 180px;
}

.table-load-more {
  border-top: 1px solid #edf0f2;
}
</style>
